import getResumeContact from '@glass/common/modules/resumes/selectors/getResumeContact';
import { ResumeType } from '@glass/common/modules/resumes/types';
import { LOCATION_FIELD_V2 } from '@glass/web/modules/resumes/fieldKeys';

const getResumeContactLocation = (resume: ResumeType) =>
  getResumeContact(resume)?.[LOCATION_FIELD_V2];

export default getResumeContactLocation;
